export default __webpack_public_path__ + "static/media/ch3-title.0fa61a7d.png";